angular.module('impactx.sidebar', []);